var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relation-badge"},[_c('div',[_vm._v(_vm._s(_vm.relation.invoiceID))]),_c('div',[_vm._v(_vm._s(_vm.relation.quantity.toLocaleString("hu"))+" "+_vm._s(_vm.unit))])])}
var staticRenderFns = []

export { render, staticRenderFns }